import { ApolloProvider } from '@apollo/client';
import baseClient from '@bottlebooks/gatsby-theme-event/src/wrapElement/apolloClient/apolloClient';
import React from 'react';
import { Provider as UrqlProvider } from 'urql';
import cmsClient from './apolloClient/apolloClientWithCms';
import urqlClient from './apolloClient/urqlClient';

export default function wrapRootElement({ element }) {
  // If Sanity CMS is active, we need to use a composite client
  return process.env.GATSBY_SANITY_PROJECT_ID ? (
    <ApolloProvider client={cmsClient}>
      {/* We use Urql because Apollo had issues with pageReference */}
      <UrqlProvider value={urqlClient}>{element}</UrqlProvider>
    </ApolloProvider>
  ) : (
    <ApolloProvider client={baseClient}>{element}</ApolloProvider>
  );
}
